import { createSlice } from '@reduxjs/toolkit';
import { ID_TOKEN_SESSION_KEY, USER_EMAIL, EMAIL } from '@/app/constants';

interface LoginState {
  tokenId: string;
  user: string;
  email: string;
  isSignedIn: boolean;
}

const initialState: LoginState = {
  tokenId: sessionStorage.getItem(ID_TOKEN_SESSION_KEY) ?? '',
  user: sessionStorage.getItem(USER_EMAIL) ?? '',
  email: sessionStorage.getItem(EMAIL) ?? '',
  isSignedIn: true,
};

const loginSlice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    setLogin: (state, action) => {
      if (action.payload.token !== undefined) {
        sessionStorage.setItem(ID_TOKEN_SESSION_KEY, action.payload.token);
      }
      if (action.payload.user !== undefined) {
        sessionStorage.setItem(USER_EMAIL, action.payload.user);
      }
      if (action.payload.email !== undefined) {
        sessionStorage.setItem(EMAIL, action.payload.email);
      }
      state.tokenId = action.payload.token;
      state.user = action.payload.user;
      state.email = action.payload.email;
    },
    clearLogin: (state) => {
      sessionStorage.removeItem(ID_TOKEN_SESSION_KEY);
      sessionStorage.removeItem(EMAIL);
      sessionStorage.removeItem(USER_EMAIL);
      state.isSignedIn = false;
      state.tokenId = '';
      state.user = '';
      state.email = '';
    },
  },
});

export const { setLogin, clearLogin } = loginSlice.actions;

export default loginSlice.reducer;
